<template>
    <b-card id="card-filtros-busca" no-body :border-variant="border">
        <b-card-header header-tag="header" role="tab">
            <div>
                <h6 class="my-auto text-left" v-b-toggle="myId">
                    <font-awesome-icon :icon="filtrosVisiveis ? 'chevron-up' : 'chevron-down'" class="mr-2" />
                    {{ titulo }}
                </h6>
            </div>
        </b-card-header>
        <b-collapse :id="myId" visible v-model="filtrosVisiveis">
            <b-card-body>
                <slot></slot>
            </b-card-body>
        </b-collapse>
    </b-card>
</template>

<script>
import { RandomId } from '@/mixins/random-id.mixin'

export default {
    name: 'CardFiltrosBusca',
    mixins: [RandomId],
    data() {
        return {
            filtrosVisiveis: true,
            myId: null,
        }
    },
    props: {
        titulo: {
            type: String,
            default: 'Filtros de busca'
        },
        border: {
            type: String,
            default: ''
        },
    },
    created() {
        this.myId = this.generateId()
    },
}
</script>

<style scoped></style>